export abstract class ValidatorBase {

    protected _message: string;
    protected _data: string;

    constructor(message: string, data: string) {
        this._message = message;
        this._data = data;
    }

    public abstract validate(value: string, messages: string[]) : void;
}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/Validators/ValidatorBase.ts
 **/